import { useLayoutEffect, useRef, useState } from 'react';

const PAD_X = 40;
const PAD_Y = 32;

function designSize(width) {
  if (width >= 1280) return { w: 850, h: 721 };
  if (width >= 768) return { w: 582, h: 669 };
  return { w: Math.max(320, width - 20), h: Math.max(480, window.innerHeight) };
}

export function useRegisterModalFit(enabled = true) {
  const shellRef = useRef(null);
  const [fit, setFit] = useState(() => {
    if (typeof window === 'undefined') return { w: 850, h: 721, scale: 1, shellW: 850, shellH: 721 };
    const { w, h } = designSize(window.innerWidth);
    const scale = Math.min(1, (window.innerWidth - PAD_X) / w, (window.innerHeight - PAD_Y) / h);
    return { w, h, scale, shellW: w * scale, shellH: h * scale };
  });

  useLayoutEffect(() => {
    if (!enabled) return undefined;

    const update = () => {
      const { w, h } = designSize(window.innerWidth);
      const availW = Math.max(280, window.innerWidth - PAD_X);
      const availH = Math.max(280, window.innerHeight - PAD_Y);
      const scale = Math.min(1, availW / w, availH / h);
      setFit({
        w,
        h,
        scale,
        shellW: Math.round(w * scale),
        shellH: Math.round(h * scale),
      });
    };

    update();
    window.addEventListener('resize', update);
    window.addEventListener('orientationchange', update);
    return () => {
      window.removeEventListener('resize', update);
      window.removeEventListener('orientationchange', update);
    };
  }, [enabled]);

  return { shellRef, fit };
}
